<script>
    import Util from 'util/util';

    export let textString = '';

    // Match groups of consecutive tokens that Unicode categorises as letters and numbers.
    $: wordCount = (Util.stripTags(textString).match(/[\p{L}\p{N}]+/ug) || []).length;
</script>

<div class="counter">
    {window.i18n.sprintf(window.i18n.ngettext('%s word', '%s words', wordCount), wordCount)}
</div>

<style lang="scss">
    .counter {
        @include normal-text;
        text-align: right;
        margin-top: 4px;
        color: $blue-black-50;
    }
</style>
